import { makeid } from 'utils/helpers/makeid';

import {
  additionalFollowUpItem,
  freeTextCommentsItem,
  isPatientCROorDNCItem,
  needEscalateItem,
  twoWaySyncInfoItem,
  uniqueDaysItem,
} from '../common';

import type { TFormItem } from '../../types';

export const spo2: TFormItem[] = [
  {
    key: makeid(10),
    title: (
      <p>
        What was the patient’s average SpO2% this week? <span>__ %</span>
      </p>
    ),
    type: 'input-number',
    required: false,
    name: 'spo2Avg',
    validation: { min: 0 },
    items: [
      {
        type: 'radio',
        name: 'spo2Avg30days',
        title: <p>Compared to the past 30 days:</p>,
        key: makeid(10),
        options: [
          { label: 'Improved', value: 'improved', key: makeid(10) },
          { label: 'Worsened', value: 'worsened', key: makeid(10) },
          {
            label: 'No significant change',
            value: 'unchanged',
            key: makeid(10),
          },
        ],
      },
      {
        type: 'radio',
        name: 'spo2Avg90days',
        title: <p>Compared to the past 90 days:</p>,
        key: makeid(10),
        options: [
          { label: 'Improved', value: 'improved', key: makeid(10) },
          { label: 'Worsened', value: 'worsened', key: makeid(10) },
          {
            label: 'No significant change',
            value: 'unchanged',
            key: makeid(10),
          },
        ],
      },
    ],
  },
  {
    key: makeid(10),
    title: (
      <p>
        What was the patient’s average pulse this week? <span>__ bpm</span>
      </p>
    ),
    type: 'input-number',
    required: false,
    name: 'pulseAvg',
    validation: { min: 0 },
    items: [
      {
        type: 'radio',
        name: 'pulseAvg30days',
        title: <p>Compared to the past 30 days:</p>,
        key: makeid(10),
        options: [
          { label: 'Improved', value: 'improved', key: makeid(10) },
          { label: 'Worsened', value: 'worsened', key: makeid(10) },
          {
            label: 'No significant change',
            value: 'unchanged',
            key: makeid(10),
          },
        ],
      },
      {
        type: 'radio',
        name: 'pulseAvg90days',
        title: <p>Compared to the past 90 days:</p>,
        key: makeid(10),
        options: [
          { label: 'Improved', value: 'improved', key: makeid(10) },
          { label: 'Worsened', value: 'worsened', key: makeid(10) },
          {
            label: 'No significant change',
            value: 'unchanged',
            key: makeid(10),
          },
        ],
      },
    ],
  },
  {
    key: makeid(10),
    title: (
      <p>
        Were all SpO2 and pulse readings this week within the target range for
        this patient?
      </p>
    ),
    type: 'radio',
    required: false,
    name: 'spo2AndPulseWithinRange',
    options: [
      { label: 'Yes', value: true, key: makeid(10) },
      {
        label: 'No (add context in free text if relevant)',
        value: false,
        key: makeid(10),
      },
    ],
    items: [
      {
        type: 'textarea',
        name: 'spo2AndPulseWithinRangeComment',
        title: null,
        key: makeid(10),
      },
    ],
  },
  { ...uniqueDaysItem('SpO2') },
  { ...twoWaySyncInfoItem },
  { ...isPatientCROorDNCItem },
  { ...additionalFollowUpItem },
  { ...needEscalateItem },
  { ...freeTextCommentsItem },
];
